import React from 'react';
import './AboutUs.css';

function AboutUs() {
    return (
        <div className="About">

            {/* About Us Section */}
            <div className="split-container-Ab">
                <div className="left-column-Ab">
                    <img
                        className="column-image3-Ab"
                        src="/images/abu1.png"
                        alt="About Quantechs"
                    />
                </div>

                <div className="right-column-Ab">
                    <h1>
                        <span className="blue-text-Ab">About </span> Us
                    </h1>

                    <p>
                        Trusted global software solutions for diverse industries. Expertise in innovative
                        Insurance and Financial Software, CRM, ERP, and Mobile solutions, tailored to each
                        client's mission. Pride in client trust, delivering exceptional service, and forging
                        transformative partnerships.
                    </p>
                </div>
            </div>

            {/* Vision and Mission Section */}
            <div className="content-2-Ab">
                <div className="vm-container-Ab">

                    <div className="vm-card-Ab">
                        <h2 className="topic-2-Ab">
                            <span className="blue-text-Ab">Our Vision</span>
                        </h2>

                        <p className="cont-2-para vision-text-Ab">
                            Elevating Tomorrow through Digital Innovation
                        </p>
                    </div>

                    <div className="vm-card-Ab">
                        <h2 className="topic-2-Ab">
                            <span className="blue-text-Ab">Our Mission</span>
                        </h2>

                        <p className="cont-2-para">
                            Revolutionize industries through innovative software solutions that drive growth, efficiency, and transformation. We are
                            committed to leveraging our expertise in cutting-edge technologies and domain
                            knowledge to craft tailor-made software products that empower businesses to thrive
                            in the digital age.
                        </p>
                    </div>

                </div>
            </div>

            {/* Goal Section */}
            <div className="content-3-Ab">
                <div className="goal-container-Ab">
                    <h2 className="topic-3-Ab">
                        <span className="blue-text-Ab">Our Goal</span>
                    </h2>

                    <p>
                        We are driven by a commitment to innovation, a customer-centric
                        approach, and a vision to be an industry leader. We empower our talented team, create
                        sustainable solutions, and measure our success by the impact our software has on our
                        clients' businesses. In an ever-evolving tech landscape, we remain agile and adaptable,
                        ensuring our solutions continue to add value.
                    </p>
                </div>
            </div>

            {/* Our Team Section */}
            <div className="content4-Ab">
                <div className="team-text-Ab">
                    <h2 className="team-title-Ab"> Quantechs Team </h2>

                    <p className="team-para-Ab">
                        Our people shine brightly, celebrated for their boundless creativity and unwavering competence.
                        Their dedication to crafting exceptional technology solutions is unparalleled, a testament to the greatness
                        they build. What truly sets them apart is the genuine pride they take in being architects of our clients'
                        software applications, contributing meaningfully to every digital masterpiece.
                    </p>

                    {/* <a href="/OurTeam">
                        <button className="team-button-Ab">Our Team</button>
                    </a> */}
                </div>

                {/* <div className="team-images-Ab">
                    <img className="img-team1-Ab" alt="Quantechs team 1" src="/images/t5.png" /> 
                    <img className="img-team2-Ab" alt="Quantechs team 2" src="/images/t2.png" />
                    <img className="img-team3-Ab" alt="Quantechs team 3" src="/images/t4.png" />
                </div> */}
            </div>

            {/* Contact CTA Section */}
            <section className="content6-Ab" aria-labelledby="about-contact-title">
                <h2 id="about-contact-title" className="head-contact-Ab">
                    Ready to build your software?
                </h2>

                <p className="contact-intro-Ab">
                    We are not just transforming industries; we are elevating the way businesses operate.
                    Let us be your bridge to cutting-edge technology, tailored solutions, and a roadmap to success.
                </p>

                <h3 className="head-contact-Ab1">Get in touch with us!</h3>

                <p className="contact-support-Ab">
                    Whether you need assistance with development, quality assurance, or support, Quantechs can help.
                    If you are interested in becoming part of our dynamic team, we encourage you to reach out.
                </p>
            </section>

        </div>
    );
}

export default AboutUs;